module.exports = __webpack_public_path__ + "img/avatar1.1a02cd5a.png";